import { getApiV2Client } from '@mi-front/api-v2';

/**
 * Builds a signed GET URL for a web-app BFF path on the unified API host.
 */
export function generateWebAppSignedUrl(
  path: string,
  params?: Record<string, string | boolean | number>,
): string {
  return getApiV2Client().generateUrl(path, {
    secure: true,
    params,
  });
}
